// Copyright (c) 2021-2024 Stockbit All rights reserved.

// @generated by protoc-gen-es v1.10.0 with parameter "target=js+dts"
// @generated from file securities/trm/core/portfolio/wsevent/v1/securities.proto (package securities.trm.core.portfolio.wsevent.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Order, PortfolioDetail, PortfolioList, PortfolioSummary } from "../../entity/v2/portfolio_pb.js";

/**
 * WebsocketResponse defines messages when sending response to websocket client
 *
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse
 */
export const WebsocketResponse = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse",
  () => [
    { no: 1, name: "action", kind: "enum", T: proto3.getEnumType(WebsocketResponse_Action) },
    { no: 2, name: "portfolio_summary", kind: "message", T: PortfolioSummary, oneof: "message" },
    { no: 3, name: "portfolio_detail", kind: "message", T: PortfolioDetail, oneof: "message" },
    { no: 4, name: "portfolio_list", kind: "message", T: PortfolioList, oneof: "message" },
    { no: 5, name: "order_detail", kind: "message", T: Order, oneof: "message" },
    { no: 6, name: "order_list", kind: "message", T: WebsocketResponse_OrderList, oneof: "message" },
    { no: 7, name: "portfolio_detail_day_trade", kind: "message", T: PortfolioDetail, oneof: "message" },
  ],
);

/**
 * Action provides various action can applied to websocket message
 *
 * @generated from enum securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action
 */
export const WebsocketResponse_Action = /*@__PURE__*/ proto3.makeEnum(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.Action",
  [
    {no: 0, name: "ACTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "ACTION_UPSERT", localName: "UPSERT"},
    {no: 2, name: "ACTION_DELETE", localName: "DELETE"},
  ],
);

/**
 * @generated from message securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList
 */
export const WebsocketResponse_OrderList = /*@__PURE__*/ proto3.makeMessageType(
  "securities.trm.core.portfolio.wsevent.v1.WebsocketResponse.OrderList",
  () => [
    { no: 1, name: "orders", kind: "message", T: Order, repeated: true },
  ],
  {localName: "WebsocketResponse_OrderList"},
);

